// LivestreamAside.js
'use strict';
import { connect } from 'react-redux';

import { FEATURE_GAMES, GIOCO_GAMES } from '../RemoteConfigKeys.js';

import getModalData from '../selector/getModalData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import toggleModal from '../action/toggleModal.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import { closeGameSicBo } from '../action/sicBoActions.js';
import LivestreamAside from '../component/LivestreamAside.jsx';
import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getStreamTokenDecodedData from '../selector/getStreamTokenDecodedData.js';
import { getShouldUseOverlayCta } from '../selector/getLivestreamComputedData.js';
import {
  ExclusivePrivateStatus,
  PRESET_PREVIEW,
} from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId, userId }) => {
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const isLiveStreaming = getLiveStreamData(
    state,
    [streamId],
    'isLiveStreaming'
  );
  const streamTokenDecodedData = getStreamTokenDecodedData(state, streamId);
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const isExclusivePrivatePerforming =
    getLiveStreamData(state, [streamId, 'exclusivePrivate'], 'status') ===
    ExclusivePrivateStatus.PERFORMING;
  const shouldUseOverlayCta = getShouldUseOverlayCta(state, streamId);
  const shouldDisplayChatInput =
    isAuthed &&
    isLiveStreaming &&
    (streamStatus === PRESET_PREVIEW ||
      !!streamTokenDecodedData ||
      (shouldUseOverlayCta && isExclusivePrivatePerforming));

  const isStreamer = meId === userId;
  const miniProfileModalId = 'MiniProfileModal';
  const miniBadgeInfoModalId = 'MiniBadgeInfoModal';
  const hasStreamToken = !!(
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken') ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'byteplusToken')
  );

  return {
    isAuthed,
    isGameOpen: getOperationData(state, ['liveStream', 'panel'], 'isGameOpen'),
    isGamePanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isGamePanelOpen'
    ),
    isSuperChatOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isSuperChatOpen'
    ),
    usingGameId: getOperationData(state, ['game'], 'usingGameId'),
    miniProfileModalId,
    miniBadgeInfoModalId,
    isMiniProfileModalOpen: ['opening', 'display'].includes(
      getModalData(state, miniProfileModalId, 'status')
    ),
    isMiniBadgeInfoOpen: ['opening', 'display'].includes(
      getModalData(state, miniBadgeInfoModalId, 'status')
    ),
    shouldDisplayChatInput,
    shouldShowTriggerPrivateCta:
      streamStatus === PRESET_PREVIEW || hasStreamToken,
    isStreamer,
    games: getRemoteConfigData(state, FEATURE_GAMES),
    giocoGames: getRemoteConfigData(state, GIOCO_GAMES),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStreamPanel: data => dispatch(setLiveStreamPanel(data)),
    closeGameSicBo: () => dispatch(closeGameSicBo()),
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LivestreamAside);
